import { REQUEST } from '../actions/action_types';
import { FETCH_REWARD_POINTS } from '../actionTypes/rewardPoints';

const initState = {
  data: [],
  extras: {
    total: 0,
    expired: {
      value: 0,
      date: ''
    }
  },
  dataNext: false,
  requestState: REQUEST.INIT
};

export default (state = initState, action) => {
  switch (action.type) {
    case FETCH_REWARD_POINTS.LOADING:
      return {
        ...state,
        dataNext: false,
        requestState: REQUEST.LOADING
      };
    case FETCH_REWARD_POINTS.SUCCESS: {
      const { data, dataNext, extras } = action.payload;
      return {
        ...state,
        data,
        dataNext,
        extras,
        requestState: REQUEST.SUCCESS
      };
    }
    case FETCH_REWARD_POINTS.FAIL:
      return {
        ...state,
        requestState: REQUEST.FAIL
      };
    default:
      return state;
  }
};
